import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
export function FailedMethodsSection() {
  const methods = [{
    title: 'Las apps de memorización',
    description: 'Te dan las respuestas pero no te entrenan para escucharlas y responderlas en tiempo real.'
  }, {
    title: 'Los videos de YouTube',
    description: 'Son generales, están en inglés, y nadie te espera mientras piensas tu respuesta.'
  }, {
    title: 'Los libros de texto',
    description: 'Son largos, aburridos y no simulan la presión real de la entrevista.'
  }, {
    title: 'Los grupos de WhatsApp',
    description: 'Tienen buena intención pero nadie ahí es oficial de inmigración.'
  }];
  return <section className="w-full bg-white" data-id="element-74">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-10 lg:py-24" data-id="element-75">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-76">
          <h2 className="text-3xl sm:text-4xl font-bold text-[#1B2A4A] mb-12 text-center" data-id="element-77">
            Por Qué los Métodos Tradicionales No Funcionan
          </h2>

          <div className="space-y-6 mb-10" data-id="element-78">
            {methods.map((method, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="flex gap-4 items-start p-6 bg-gray-50 rounded-lg border border-gray-200" data-id="element-79">
                <XCircleIcon className="w-8 h-8 text-red-500 flex-shrink-0 mt-1" data-id="element-80" />
                <div data-id="element-81">
                  <h3 className="font-bold text-lg text-gray-900 mb-2" data-id="element-82">
                    {method.title}
                  </h3>
                  <p className="text-gray-700" data-id="element-83">{method.description}</p>
                </div>
              </motion.div>)}
          </div>

          <motion.p initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.5
        }} className="text-xl text-center font-semibold text-[#1B2A4A]" data-id="element-84">
            Ninguno de estos métodos ataca el problema real: la ansiedad de la
            entrevista en vivo.
          </motion.p>
        </motion.div>
      </div>
    </section>;
}